import {Router} from '@angular/router';
import {authGuard} from './auth.guard';

/**
 * True when the router's current (activated) route, or any of its ancestors, is
 * protected by authGuard. Unguarded routes such as /samples are never treated as
 * needing a session, and nor is the initial empty state before the first navigation
 * has completed.
 */
export function routeRequiresAuth(router: Router): boolean {
  let route = router.routerState.snapshot.root;
  while (route) {
    if (route.routeConfig?.canActivate?.includes(authGuard)) {
      return true;
    }
    route = route.firstChild!;
  }
  return false;
}
